import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dynamic from '@base/Dynamic/Dynamic';
import useCaptureImageClicked from './useCaptureImageClicked';

const ImagePreviewDialog = Dynamic(() =>
  import('@educator/Composite/ImageContainer/ImagePreviewDialog')
);

const WithPreviewImage = ({ children }) => {
  const [timesRotated, setTimesRotated] = useState(0);
  const { previewURL, clearPreviewURL, handleOnClick } =
    useCaptureImageClicked();

  const getProcessedChild = () => {
    return React.cloneElement(children, {
      'data-image-preview-boundary': 'data-image-preview-boundary',
      onClickCapture: handleOnClick
    });
  };

  const showImagePreview = previewURL !== null;

  useEffect(() => {
    setTimesRotated(0);
  }, [previewURL]);

  return (
    <>
      {getProcessedChild()}
      <ImagePreviewDialog
        showPreviewModal={showImagePreview}
        onPreviewModalClose={clearPreviewURL}
        previewURL={previewURL}
        timesRotated={timesRotated}
        setTimesRotated={setTimesRotated}
      />
    </>
  );
};

export default WithPreviewImage;

WithPreviewImage.propTypes = {
  children: PropTypes.node.isRequired
};
